import { Directive, inject, input, effect, TemplateRef, ViewContainerRef, untracked } from '@angular/core';

import { AppFeatureFlagsService } from './app-feature-flags.service';
import { FeatureFlags } from './features.enum';

@Directive({
  selector: '[ciphrAppFeatureFlag]',
  standalone: true,
})
export class AppFeatureFlagsDirective {
  private appFeatureFlagsService = inject(AppFeatureFlagsService);

  private viewContainerRef = inject(ViewContainerRef);
  private templateRef = inject(TemplateRef);

  requiredFeature = input.required<FeatureFlags>({ alias: 'ciphrAppFeatureFlag' });

  constructor() {
    this.viewContainerRef.clear();

    effect(() => {
      if (this.appFeatureFlagsService.hasFeatures(this.requiredFeature())) {
        untracked(() => {
          this.viewContainerRef.createEmbeddedView(this.templateRef);
        });
      }
    });
  }
}
